/** @format */

import React from "react";
import PropTypes from "prop-types";
import css from "styled-jsx/css";
import config from "lib/config";
const errorBg = `${config.CDN_PREFIX}/static/assets/images/bg-error-404.jpg`;

import getLogger from "logger/index";
const log = getLogger("Error Component");
// This component can be imported anywhere and rendered in place of content, in the case of errors.

const styles = css`
  .error-404,
  .error-500 {
    position: relative;
    min-height: 600px;
    background-size: cover;
    background-position: center top;
    color: #fff;
  }

  .error-404 .heading,
  .error-500 .heading {
    padding-top: 200px;
    font-size: 3.5em;
    font-weight: 400;
    margin: 0 0 10px;
  }
  .error-404 .subheading,
  .error-500 .subheading {
    font-size: 2em;
    font-weight: 400;
    margin: 0 0 10px;
    line-height: 1.1;
  }
`;

const render404 = () => {
  const backgroundImage = `url(${errorBg})`;

  return (
    <div id="error-404" className="error-404" style={{ backgroundImage }}>
      <style jsx>{styles}</style>
      <div className="container">
        <div className="row">
          <div className="col-md-offset-1 col-lg-4 col-md-5 col-xs-7">
            <h1 className="heading">We&rsquo;re Sorry.</h1>
            <h2 className="subheading">
              It appears we came up empty and couldn&rsquo;t find what you were looking for.
            </h2>
            <p>
              Please try again or contact{" "}
              <a className="email-link" href="mailto:support@realtor.com">
                support@realtor.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const render500 = (message) => {
  const backgroundImage = `url(${errorBg})`;

  return (
    <div id="error-500" className="error-500" style={{ backgroundImage }}>
      <style jsx>{styles}</style>
      <div className="container">
        <h1 className="heading">{message}</h1>
        <p>
          We&rsquo;re sorry, looks like we have some internal server errors.
          <br />
          Please try again or contact{" "}
          <a className="email-link" href="mailto:support@realtor.com">
            support@realtor.com
          </a>
        </p>
        <p></p>
        <span className="hidden-text">{new Date().toString()}</span>
      </div>
    </div>
  );
};

const ErrorComponent = (props) => {
  const { statusCode, err, urlInfo, status_code } = props;
  err ? log.error(`Client side error: request_url: ${urlInfo} status: ${statusCode}`, err) : null;

  const content = statusCode === 404 || status_code == 404 ? render404() : render500();
  return <>{content}</>;
};

ErrorComponent.propTypes = {
  statusCode: PropTypes.number,
  err: PropTypes.number,
  status_code: PropTypes.number,
  urlInfo: PropTypes.string,
};

export default ErrorComponent;
